module.exports = __webpack_public_path__ + "media/images/emblems/Meggen_LU-16d64e5ac609b9125b347da2a991cd67.png";